export const PAGE_GAP = 'ellipsis';
export const USER_LEVEL_MENTOR_STATISTICS = 5;
export const USER_LEVEL_STATISTICS = 4;
export const USER_LEVEL_MENTOR = 3;
export const USER_LEVEL_COMMUNICATION = 2;
export const USER_LEVEL_ADMIN = 1;
export const USER_LEVEL_START = 0;
export const ALLOWED_PATHS_STATISTICS = ['/commission', '/graphic'];
export const ALLOWED_PATHS_MENTORS = ['/graphic', '/commission'];
export const STUDENT_STATES = { ACTIVE: 'up' };
export const DEFAULT_INSTALLMENT_QUANTITY = 12;

export const EXPORT_OPTIONS = {
  CURRENT: 'current',
  PREVIOUS: 'previous',
  FILTERS: 'filters',
};
export const DISPLAY_TYPES = {
  SPECIFIC: 'specific',
  ANUAL: 'anual',
  SIX_MONTHS: 'sixMonths',
  HISTORIC: 'historic',
  RANGE_12M: '12m',
  RANGE_24M: '24m',
  RANGE_36M: '36m',
};
export const BUTTON_VARIANTS = {
  PRESET_ACTIVE: 'primary',
  PRESET_INACTIVE: 'outline-secondary',
  YEAR_ACTIVE: 'dark',
  YEAR_INACTIVE: 'outline-light',
};
export const PRESET_MONTHS_BACK = {
  [DISPLAY_TYPES.RANGE_12M]: 11,
  [DISPLAY_TYPES.RANGE_24M]: 23,
  [DISPLAY_TYPES.RANGE_36M]: 35,
};
export const EXCEL_CONFIG = {
  SHEET_NAME: 'Ingresos',
  FILE_PREFIX: 'Ingresos',
  DATE_FORMAT: 'YYYY-MM-DD',
  FILE_TIMESTAMP_FORMAT: 'YYYY-MM-DD_HH-mm-ss',
  COLUMN_WIDTH: 20,
};
export const METRIC_SALES_YEAR_RANGE_SIZE = 10;
export const TAB_SALES_METRICS = 'sales-metrics';
export const COMMISSION_STATES_FINISHED  = { FINISHED: 'down' };
export const SALES_ORIGIN_TEXT = {
  TITLE_PREFIX: 'Origen de alumnos - Día',
  SALES_LABEL: 'ventas',
  NO_SALES_MESSAGE: 'Sin ventas este día',
  UNDEFINED_LOCATION: 'Sin definir',
  UNLINKED_STUDENT: 'Sin alumno vinculado',
  GUESSED_HINT: 'Estimado por número de teléfono',
  TOOLTIP_HINT: 'Click o Enter para ver origen de alumnos',
};
export const EXTERNAL_REF = {
  RCSM_LINK: 'RCSM-LINK',
};